import { create } from 'zustand';

/**
 * Dunkler Modus (SPEC Kap. 12): Kellerräume sind schlecht beleuchtet, ein
 * heller Bildschirm blendet dort. Die Wahl liegt in IndexedDB, nicht in
 * `localStorage` (CLAUDE.md §2) — bis sie geladen ist, gilt die Systemvorgabe.
 */

export type Farbmodus = 'hell' | 'dunkel' | 'system';

interface DarstellungsZustand {
  modus: Farbmodus;
  setzeModus: (modus: Farbmodus) => void;
}

const systemBevorzugtDunkel = (): boolean =>
  typeof window !== 'undefined' &&
  window.matchMedia?.('(prefers-color-scheme: dark)').matches === true;

export const wendeModusAn = (modus: Farbmodus): void => {
  if (typeof document === 'undefined') return;
  const dunkel = modus === 'dunkel' || (modus === 'system' && systemBevorzugtDunkel());
  document.documentElement.classList.toggle('dunkel', dunkel);
};

export const useDarstellung = create<DarstellungsZustand>((set) => ({
  modus: 'system',
  setzeModus: (modus) => {
    wendeModusAn(modus);
    set({ modus });
  },
}));

/** Reagiert auf Systemwechsel, solange „system" eingestellt ist. */
export const beobachteSystemModus = (): (() => void) => {
  if (typeof window === 'undefined' || !window.matchMedia) return () => undefined;
  const abfrage = window.matchMedia('(prefers-color-scheme: dark)');
  const beiWechsel = (): void => {
    if (useDarstellung.getState().modus === 'system') wendeModusAn('system');
  };
  abfrage.addEventListener('change', beiWechsel);
  return () => abfrage.removeEventListener('change', beiWechsel);
};
